import * as Swiper from 'swiper/dist/js/swiper.js'; 

export default class reboundSlider {
    constructor() {
        this.container = document.querySelector('.js-rebound-slider');
        if (this.container === null) return;

        this.sliders = document.querySelectorAll('.js-rebound-slider');
        this.sliders.forEach((slider) => this.initSlider(slider) )
    }

    initSlider(slider) {
        let slidesPerViewResponsive;
        let spaceBetweenResponsive;

        if(window.innerWidth >= 1024){
			slidesPerViewResponsive = 3
            spaceBetweenResponsive = 24
        }else if(window.innerWidth >= 768){
			slidesPerViewResponsive = 2
            spaceBetweenResponsive = 24
        }else if(window.innerWidth < 768) {
            slidesPerViewResponsive = 1
            spaceBetweenResponsive = 20
        }

        new Swiper(slider, {
           	slidesPerView: slidesPerViewResponsive,
			spaceBetween: spaceBetweenResponsive,
            slideClass: 'item',
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                bulletClass: 'swiper-pagination-bullet',
                bulletActiveClass: '-current',
                clickable: true,
            },
            
        });
    }
}
